var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sh-gmail-card',{attrs:{"content-path":"/gmail-intro.html"}})
}
var staticRenderFns = []

export { render, staticRenderFns }